import React from 'react'
import { bool, func, string } from 'prop-types'
import classnames from 'classnames'

const TabItem = ({ title, active, onClick }) => {
  const classNameVal = classnames('tab-item', {
    active,
  })
  return (
    <div className={classNameVal} onClick={onClick}>
      <span className="tab-item__title">
        { title }
      </span>
      <span className="tab-item__title-mobile">
        { title.substring(0, 1) }
      </span>
      <style jsx>
        {`
          .tab-item {
            position: relative;
            flex-grow: 1;
            text-align: center;
            padding: 16px 24px;
            cursor: pointer;
            &__title, &__title-mobile {
              color: #6b8fbc;
              font-weight: bold;
              font-size: 16px;
            }
            &__title {
              display: none;
              @media screen and (min-width: 767px) {
                display: inline-block;
              }
            }
            &__title-mobile {
              display: inline-block;
              @media screen and (min-width: 767px) {
                display: none;
              }
            }
            &::before {
              content: "";
              width: 100%;
              height: 4px;
              border-radius: 4px;
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
            }
            &.active {
              .tab-item__title {
                color: #0c2846;
              }
              &::before {
                background-color: #00cbae;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

TabItem.propTypes = {
  title: string,
  active: bool,
  onClick: func,
}

export default TabItem
